module.exports = __webpack_public_path__ + "media/bootstrap-icons/border-top-6a86ee00.svg";